<template>
  <div id="app">
    <Header />
    <router-view id="router-view" />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer
  }
};
</script>

<style>
/* Import local Avenir files */
@font-face {
  font-family: "Avenir";
  src: local("Avenir"),
   url(./fonts/Avenir-Book.ttf) format("truetype");
}

@font-face {
  font-family: "Avenir Black";
  src: local("Avenir Black"),
   url(./fonts/Avenir-Black.ttf) format("truetype");
}

* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; */
  color: #1d3336;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#router-view {
  flex: 1;
}

.result {
  font-weight: 800;
}

select,
input,
button {
  padding: 5px;
  font-family: "Avenir Black", Avenir, Helvetica, Arial, sans-serif;
  border: none;
  border-radius: 4px;
}

p {
  font-size: 14pt;
}
</style>
